import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight, ShoppingBag } from "lucide-react";
import { StatusBadge } from "./StatusBadge";
import { UnreadDot } from "./UnreadDot";

/**
 * Order row card.
 *   order = { id, business_name, order_id_label, date, amount, status, items_count }
 */
export function OrderCard({ order, to, testid }) {
  const dateStr = order.date
    ? new Date(order.date).toLocaleDateString("en-IN", { day: "2-digit", month: "short" })
    : "";
  const Body = (
    <div
      data-testid={testid || `order-card-${order.id}`}
      className="bg-white border border-slate-100 rounded-2xl p-4 hover:shadow-md hover:border-slate-200 transition-all duration-200 active:scale-[0.99]"
    >
      <div className="flex items-start gap-3">
        <div className="w-11 h-11 rounded-2xl bg-emerald-50 text-emerald-600 grid place-items-center shrink-0">
          <ShoppingBag className="w-5 h-5" strokeWidth={2.2} />
        </div>
        <div className="min-w-0 flex-1">
          <div className="flex items-center justify-between gap-2">
            <div className="min-w-0 flex-1 flex items-center gap-1.5">
              <UnreadDot entityId={order.id} />
              <div className="min-w-0">
                <div className="font-semibold text-slate-900 truncate">{order.business_name}</div>
                {order.enquiry_title && (
                  <div
                    data-testid={`order-enquiry-title-${order.id}`}
                    className="text-[11px] font-semibold text-indigo-600 truncate"
                  >
                    {order.enquiry_title}
                  </div>
                )}
              </div>
            </div>
            <StatusBadge status={order.status} />
          </div>
          <div className="text-xs text-slate-500 mt-0.5 flex items-center gap-1.5 flex-wrap">
            <span className="font-mono">#{order.order_id_label}</span>
            {dateStr && <span>· {dateStr}</span>}
            {order.items_count != null && <span>· {order.items_count} items</span>}
          </div>
          <div className="flex items-center justify-between mt-2">
            <span className="text-base font-bold text-slate-900">
              ₹{(order.amount ?? 0).toLocaleString("en-IN")}
            </span>
            <ChevronRight className="w-4 h-4 text-slate-300" />
          </div>
        </div>
      </div>
    </div>
  );
  if (to) return <Link to={to}>{Body}</Link>;
  return Body;
}
